<script setup lang="ts">
import {useElementSize} from '@vueuse/core';
import {onMounted, ref, watchEffect} from 'vue';
import {useStore} from './store';
import ErrorScreen from './view/ErrorScreen';
import LoadingScreen from './view/LoadingScreen';
import VisualiserScreen from './view/VisualiserScreen';

const store = useStore();

const containerRef = ref<HTMLElement | null>(null);
const {width, height} = useElementSize(containerRef);

watchEffect(() => {
    window.parent.postMessage({type: 'visualiser-resize', height: height.value}, '*');
});

onMounted(() => {
    store.preloadData();
});
</script>

<template>
    <div ref="containerRef" class="visualiser-container">
        <transition name="screen" mode="out-in">
            <ErrorScreen v-if="store.view === 'error'" key="ErrorScreen" />
            <LoadingScreen v-else-if="store.view === 'loading'" key="LoadingScreen" />
            <VisualiserScreen v-else-if="store.view === 'visualiser'" key="VisualiserScreen" />
        </transition>
    </div>
</template>
